import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { authService } from '../services/authService';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token') || null);
  const user = ref(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null);
  const error = ref('');

  const isAuthenticated = computed(() => !!token.value && !!user.value);
  const isAdmin = computed(() => user.value?.role === 'ADMIN');
  const isAnalyst = computed(() => user.value?.role === 'ANALYST');

  const login = async (username, password) => {
    error.value = '';
    try {
      const normalizedUsername = String(username || '').trim();
      const normalizedPassword = String(password || '').trim();
      const response = await authService.login(normalizedUsername, normalizedPassword);

      if (response.token && response.user) {
        token.value = response.token;
        user.value = response.user;

        localStorage.setItem('token', response.token);
        localStorage.setItem('user', JSON.stringify(response.user));
        authService.setToken(response.token);

        return true;
      }

      error.value = 'Falha na autenticacao';
      return false;
    } catch (err) {
      const responseData = err.response?.data || null;
      if (responseData) {
        console.error('[LOGIN] backend response:', responseData);
      }
      const rawError = responseData?.error || err.message || 'Erro ao conectar com servidor';
      error.value = /credenciais/i.test(rawError) ? 'Credenciais invalidas' : rawError;
      return false;
    }
  };

  const logout = () => {
    token.value = null;
    user.value = null;
    error.value = '';
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    authService.clearToken();
  };

  const restoreSession = () => {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (savedToken && savedUser) {
      token.value = savedToken;
      user.value = JSON.parse(savedUser);
      authService.setToken(savedToken);
      return true;
    }

    return false;
  };

  return {
    token,
    user,
    error,
    isAuthenticated,
    isAdmin,
    isAnalyst,
    login,
    logout,
    restoreSession
  };
});
